import styled from 'styled-components'

import { HEADER_HEIGHT_DESKTOP } from '../Quiz/components/Header/styled'

import { color, fontWeight } from 'src/styles'
import { media } from 'src/styles/media'
import { fontSize } from 'src/styles/fonts'

export const Wrap = styled.div`
  display: flex;
  justify-content: center;
`

export const ContentWrap = styled.div`
  min-height: 100%;
  padding-top: ${HEADER_HEIGHT_DESKTOP}rem;
  display: flex;
  flex-direction: column;
  padding: 2.4rem;
  max-width: 96rem;
`

export const Heading = styled.h2`
  font-size: ${fontSize.LARGE_XXXL};
  color: ${color.GREYISH_BROWN};
  font-weight: ${fontWeight.EXTRA};
  margin: 1.5rem 0 3rem;

  ${media.desktop} {
    margin: 2rem 0 6rem;
    font-size: 4rem;
  }
`

export const SubTitle = styled.h3`
  font-size: ${fontSize.NORMAL};
  color: ${color.GREYISH_BROWN};
  font-weight: ${fontWeight.BOLD};
  line-height: 2.4rem;
  margin: 3rem 0 0;
`

export const Paragraph = styled.p`
  font-size: ${fontSize.NORMAL};
  color: ${color.WARM_GREY};
  font-weight: ${fontWeight.REGULAR};
  line-height: 2.4rem;
  margin: 0;
`

export const UnorderedList = styled.ul`
  font-size: ${fontSize.NORMAL};
  color: ${color.WARM_GREY};
`

export const ListItem = styled.li`
  & + & {
    margin-top: 0.5rem;
  }
`

export const Anchor = styled.a`
  color: ${color.DUSTY_ORANGE};
  font-weight: ${fontWeight.BOLD};

  :visited {
    color: ${color.DUSTY_ORANGE};
  }
`
